module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/node_modules/babel-runtime/core-js/object/set-prototype-of.js
// module id = 1059
// module chunks = 1 2 3